import { render, staticRenderFns } from "./SpecialtyCards.vue?vue&type=template&id=9816d6c0&"
import script from "./SpecialtyCards.vue?vue&type=script&lang=js&"
export * from "./SpecialtyCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports